import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const Disclaimer = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.Disclaimer');
    return (
        <>
            <div className={styles.disclaimer}>
                <div className={`item`}>
                    <div className="desc">{t(`text`)}</div>
                </div>

                <div className={`item`}>
                    <div className="desc">{t(`text1`)}</div>
                </div>
            </div>
        </>
    );
};

export default Disclaimer;
